// @flow
import React, { PureComponent } from 'react';
import Label from 'components/fragments/text/Label';
import type { CategoryArticleType } from 'types/Article';


export type StateProps = {
  categoriesArticle: CategoryArticleType[]
};

class Themes extends PureComponent<StateProps>{

  renderThemeList = () => {
    const { categoriesArticle } = this.props;

    return categoriesArticle.map<any>((category, index) => (
      <li key={index}>
        <Label label={category.name} link={`/actualites/${category.slug}`} />
      </li>
    ));
  };

  render(){
    return (
      <div className="row">
        <div className="col col-lg-8on9">
          <div className="box box--grey block-label mb-6 mb-md-7">
            <p className="ft-500">Par thématiques :</p>
            <ul>{this.renderThemeList()}</ul>
          </div>
        </div>
      </div>
    );
  }
}


export default Themes;
